var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',[_c('h3',[_vm._v("Component test")]),_c('b-container',{staticClass:"bv-example-row",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"xl":"3"}},[_c('AnnouncementImage',{attrs:{"id":941}})],1),_c('b-col',{attrs:{"xl":"3"}},[_c('AnnouncementImage',{attrs:{"id":942}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }